
import { useMemo } from "react";

import { useStudioRuntime } from "../StudioRuntimeContext";

function assertCapabilityType(type) {
  if (typeof type !== "string" || type.trim() === "") {
    throw new TypeError(
      "useStudioContributions.type must be a non-empty string."
    );
  }

  return type.trim();
}

/**
 * Resolves the immutable and priority-ordered contributions registered
 * in the current StudioRuntime for one capability type.
 *
 * This hook contains no domain-specific or presentation responsibility.
 */
export default function useStudioContributions(type) {
  const runtime = useStudioRuntime();
  const normalizedType = assertCapabilityType(type);

  return useMemo(
    () => runtime.resolveContributions(normalizedType),
    [normalizedType, runtime]
  );
}

export {
  assertCapabilityType,
};
